import enUS from '../../date-picker/locale/en_US';
export default enUS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/calendar/locale/en_US.js
// module id = 209
// module chunks = 0